import { IUserSession } from '../interfaces/IUserSession';

export interface IRefreshResponseData {
    token: string;
    logoutToken?: string;
    roles?: string[];
    companies?: Array<{ id: string; name: string }>;
    configuration?: { selectedCompanyId?: string; isTestCompany?: boolean };
}

const DEFAULT_PRIMARY_COLOUR = '#493193';
const DEFAULT_SECONDARY_COLOUR = '#2fadd8';

/**
 * Applies a token refresh to the stored session. Roles, organisations and the selected organisation are taken
 * from the server so a membership removed elsewhere no longer lingers in the client. Organisation branding is
 * reset only when the selected organisation actually changes.
 */
export function applyRefreshToSession(session: IUserSession, data: IRefreshResponseData): IUserSession {
    const next: IUserSession = {
        ...session,
        token: data.token,
        logoutToken: data.logoutToken ?? session.logoutToken,
        ...(Array.isArray(data.roles) && { roles: data.roles }),
        ...(Array.isArray(data.companies) && { companies: data.companies }),
    };

    const selectedCompanyId = data.configuration?.selectedCompanyId;
    if (selectedCompanyId === undefined || !session.configuration) {
        return next;
    }

    const isTestCompany = data.configuration?.isTestCompany ?? false;
    next.configuration = selectedCompanyId === session.configuration.selectedCompanyId
        ? { ...session.configuration, IsTestCompany: isTestCompany }
        : {
            selectedCompanyId,
            mode: 'light',
            primaryColour: DEFAULT_PRIMARY_COLOUR,
            secondaryColour: DEFAULT_SECONDARY_COLOUR,
            IsTestCompany: isTestCompany,
        };

    return next;
}
